import { createSlice } from "@reduxjs/toolkit";
import { Client, DepositAddress, UserProfile } from "../../api/api";
import { setter } from "../utils/setter";

export interface UserState {
  profile?: UserProfile,
  client?: Client,
  deposits?: DepositAddress[]
}

const initialState: UserState = {};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setProfile: setter(initialState,'profile'),
    setClient: setter(initialState,'client'),
    setDeposits: setter(initialState, 'deposits'),
    logout: () => initialState
  }
})
